export default "/_next/static/images/5ea973f4fffe17a131c8b4f81f493016.jpg";